const getAge = (dateOfBirth: string) => {
  const date = new Date(dateOfBirth)
  const today = Date.now()

  const diff = today - date.getTime()
  const age = Math.floor(diff / 31556926000) // 1 year in milliseconds

  return age
}

export default getAge
